"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _OutboundLink = _interopRequireDefault(require("../../../atoms/OutboundLink"));

var _InternalLink = _interopRequireDefault(require("../../../atoms/InternalLink"));

var _Event = _interopRequireDefault(require("../../../darkmatter/Event"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var _default = function _default(_ref) {
  var internal = _ref.internal,
      slug = _ref.slug,
      body = _ref.body,
      as = _ref.as,
      gatsbyLink = _ref.gatsbyLink,
      style = _ref.style;
  var event = {
    category: 'CTA',
    action: 'click',
    label: 'Card Navigation'
  };
  var linkElementStyle = {
    width: '100%',
    height: '100%'
  };

  var styledBody = _react["default"].createElement("div", {
    style: {
      width: '100%',
      textAlign: 'center'
    }
  }, body);

  if (internal) {
    return _react["default"].createElement(_Event["default"], {
      event: event,
      eventType: "click"
    }, _react["default"].createElement(_InternalLink["default"], {
      to: slug,
      as: as,
      gatsbyLink: gatsbyLink,
      style: _objectSpread({}, linkElementStyle, {}, style)
    }, styledBody));
  }

  return _react["default"].createElement(_Event["default"], {
    event: event,
    eventType: "click"
  }, _react["default"].createElement(_OutboundLink["default"], {
    to: slug,
    as: as,
    gatsbyLink: gatsbyLink,
    style: _objectSpread({}, linkElementStyle, {}, style)
  }, styledBody));
};

exports["default"] = _default;